import React, { useEffect, useState } from "react";
import styles from "./Header.module.scss";
import { Icon } from "../../assets/Icons.tsx";
import classNames from "classnames";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import HeaderLogo from "../../assets/images/HeaderLogo.png";
import { Offcanvas } from "react-bootstrap";
import { motion } from "framer-motion";


export default function Header() {
  const [showMenuPop, setShowMenuPop] = useState(false);
  const { pathname } = useLocation();
  const menuItems = [
    {
      title: "About Us",
      link: "/about-us",
      subMenu: [
        { title: "Overview", link: "" },
        {title:"Mission & Vision",link:"/mission-vision"},
        {title:"Awards & Achievements",link:"/award-achievement"},
        // { title: "Why Choose Aptech", link: "/why-choose-aptech" },
        // { title: "Alliances", link: "/alliances" },
        // { title: "Leadership Team", link: "/our-leadership-team" },
        {
          title: "Corporate Social Responsibility",
          link: "/corporate-social-responsibility",
        },
      ],
    },
    {
      title: "Our Businesses",
      link: "/our-businesses",
      subMenu: [
        { title: "Overview", link: "" },
        // { title: "Institutional Business", link: "/institutional-business" },
        {title:"Domestic Retail",link:"/invidual"},
        {title:"Institutional Business",link:"/institutional-business"},
        {title:"International Retail",link:"/global-retails"}



      ],
    },
    // {
    //   title: "Student World",
    //   link: "/students-world",
    //   subMenu: [
    //     { title: "Alumni Achievements", link: "" },
    //     { title: "Students’ Work", link: "/students-work" },
    //     { title: "Scholarship & Financial Aid", link: "/students-support" },
    //     { title: "Placements at Aptech", link: "/placements-at-aptech" },
    //     { title: "ProConnect", link: "/proconnect" },
    //   ],
    // },
    {
      title: "Investors",
      link: "/investors",
      subMenu: [
        { title: "Overview", link: "" },
        { title: "News & Notifications", link: "/news-and-notifications" },
        { title: "Board of Directors", link: "/board-of-directors" },
        { title: "Shareholders", link: "/shareholders" },
        {
          title: "Filings with Stock Exchanges",
          link: "/filings-with-stock-exchanges",
        },
        { title: "Results and Reports", link: "/results-and-reports" },
      ],
    },
    {
      title: "News & Media",
      link: "/news-and-media",
      subMenu: [
        { title: "Press Releases", link: "/press-releases" },
        { title: "Aptech in News", link: "/aptech-in-news" },
        { title: "Media Kit", link: "/media-kit" },
      ],
    },
    { title: "Careers with Aptech", link: "/careers-with-aptech", subMenu: [] },

    { title: "Partner with Aptech", link: "/partner-with-aptech", subMenu: [] },
   
    // { title: "Contact Us", link: "/contact-us", subMenu: [] },
  ];

  useEffect(() => {
    setShowMenuPop(false);
  }, [pathname]);

  return (
    <>
      <div className={classNames(styles.Header, "sticky-top")}>
        <div className="container-fluid">
          <div className={styles.headerPadding}>
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex">
              <div className={styles.logo}>
                <NavLink to="/">
                  <img src={HeaderLogo} alt="logo" />
                </NavLink>
              </div>
              <div className={styles.menulist}>
                {menuItems.map((menu, i) => {
                  return <Menu menu={menu} key={i} />;
                })}
              </div>
            </div>
            <div>
              <div className={styles.menuBtn}>
                <div className={styles.contactUsIcon}>
                <NavLink to="/contact-us">

                <Icon name="contactUsIcon" />
                </NavLink>
                </div>
                <button onClick={() => setShowMenuPop(true)}>
                  Menu <Icon name="menuIcon" />
                </button>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>

      {showMenuPop && (
        <OpenMenu showMenuPop={showMenuPop} setShowMenuPop={setShowMenuPop} />
      )}
    </>
  );
}

const Menu = ({ menu, popup = false }) => {
  const [showSubMenu, setShowSubMenu] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const mainRoot = pathname.split("/")[1];
  return (
    <div
      className={classNames(
        styles.menuItem,
        "/" + mainRoot === menu.link ? styles.active : "",
        popup ? styles.menuPopup : "d-none d-md-block"
      )}
      onMouseEnter={() => setShowSubMenu(true)}
      onMouseLeave={() => setShowSubMenu(false)}
    >
      <span onClick={() => !menu?.subMenu.length > 0 && navigate(menu.link)}>
        {menu.title}
      </span>
      {popup && menu.subMenu.length > 0 ? <Icon name="angleDown" /> : null}

      {menu?.subMenu.length > 0 && showSubMenu ? (
        <div className={styles.subMenu}>
          <SubMenu menu={menu} />
        </div>
      ) : null}
    </div>
  );
};

const SubMenu = ({ menu }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <>
      {menu?.subMenu?.map((submenu, j) => {
        return (
          <div
            key={j}
            className={classNames(
              styles.subMenuItem,
              pathname === menu.link + submenu.link ? styles.active : ""
            )}
          >
            <span onClick={() => navigate(`${menu.link}${submenu.link}`)}>
              {submenu.title}
            </span>
          </div>
        );
      })}
    </>
  );
};

const OpenMenu = ({ showMenuPop, setShowMenuPop }) => {
  const [openSubMenu, setOpenSubMenu] = useState(null); // Track open submenu

  const allItems = [
    {
      title: "About Us",
      link: "/about-us",
      subMenu: [
        { title: "Overview", link: "" },
        {title:"Mission & Vision",link:"/mission-vision"},
        {title:"Awards & Achievements",link:"/award-achievement"},
        // { title: "Why Choose Aptech", link: "/why-choose-aptech" },
        // { title: "Alliances", link: "/alliances" },
        // { title: "Leadership Team", link: "/our-leadership-team" },
        {
          title: "Corporate Social Responsibility",
          link: "/corporate-social-responsibility",
        },
      ],
    },
    {
      title: "Our Businesses",
      link: "/our-businesses",
      subMenu: [
        { title: "Overview", link: "" },
        // { title: "Institutional Business", link: "/institutional-business" },
        {title:"Domestic Retail",link:"/invidual"},
        {title:"Institutional Business",link:"/institutional-business"},
        {title:"International Retail",link:"/global-retails"}



      ],
    },
    {
      title: "Investors",
      link: "/investors",
      subMenu: [
        { title: "Overview", link: "" },
        { title: "News & Notifications", link: "/news-and-notifications" },
        { title: "Board of Directors", link: "/board-of-directors" },
        { title: "Shareholders", link: "/shareholders" },
        {
          title: "Filings with Stock Exchanges",
          link: "/filings-with-stock-exchanges",
        },
        { title: "Results and Reports", link: "/results-and-reports" },
      ],
    },
    {
      title: "News & Media",
      link: "/news-and-media",
      subMenu: [
        { title: "Press Releases", link: "/press-releases" },
        { title: "Aptech in News", link: "/aptech-in-news" },
        { title: "Media Kit", link: "/media-kit" },
      ],
    },
    // {
    //   title: "Student World",
    //   link: "/students-world",
    //   subMenu: [
    //     { title: "Alumni Achievements", link: "/alumni-achievements" },
    //     { title: "Students’ Work", link: "/students-work" },
    //     { title: "Scholarship & Financial Aid", link: "/students-support" },
    //     { title: "Placements at Aptech", link: "/placements-at-aptech" },
    //     { title: "ProConnect", link: "/proconnect" },
    //   ],
    // },
    // { title: "Events at Aptech", link: "/events-at-aptech", subMenu: [] },
    { title: "Careers with Aptech", link: "/careers-with-aptech", subMenu: [] },
    { title: "Partner with Aptech", link: "/partner-with-aptech", subMenu: [] },
   
    // { title: "Awards", link: "/awards-at-aptech", subMenu: [] },

   

    { title: "Contact Us", link: "/contact-us", subMenu: [] },
    // { title: "Sitemap", link: "/sitemap", subMenu: [] },
  ];
  return (
    <Offcanvas
      show={showMenuPop}
      placement="end"
      onHide={() => setShowMenuPop(false)}
      className={styles.menuPop}
    >
      <Offcanvas.Header closeButton>
        <div className={styles.logo}>
          <NavLink to="/">
            <img src={HeaderLogo} alt="logo" />
          </NavLink>
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className={styles.OpenMenu}>
          <div className={styles.menuList}>
            {allItems.map((menu, i) => (
              <MenuPopup
                menu={menu}
                key={i}
                openSubMenu={openSubMenu}
                setOpenSubMenu={setOpenSubMenu}
              />
            ))}
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

const MenuPopup = ({ menu, openSubMenu, setOpenSubMenu }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const mainRoot = pathname.split("/")[1];

  const isSubMenuOpen = openSubMenu === menu.title;
  const [hover, setHover] = useState(false);

  const toggleSubMenu = (e) => {
    e.stopPropagation();
    setOpenSubMenu(isSubMenuOpen ? null : menu.title); // Close other submenus
  };

  return (
    <div
      className={classNames(styles.menuItem)}
      onClick={toggleSubMenu}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div
        className={classNames(
          styles.menuPopup,
          "/" + mainRoot === menu.link ? styles.active : ""
        )}
      >
        <span onClick={() => !menu?.subMenu.length > 0 && navigate(menu.link)}>
          {menu.title}
        </span>

        {menu.subMenu.length > 0 && (
          <div onClick={toggleSubMenu}>
            <Icon
              name={isSubMenuOpen ? "angleUp" : "angleDown"}
              color={
                isSubMenuOpen || "/" + mainRoot === menu.link || hover
                  ? "white"
                  : ""
              }
            />
          </div>
        )}
      </div>

      {menu?.subMenu.length > 0 && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{
            opacity: isSubMenuOpen ? 1 : 0,
            y: isSubMenuOpen ? 0 : -10,
          }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          style={{ display: isSubMenuOpen ? "block" : "none" }}
        >
          <div className={styles.subMenu}>
            <SubMenu menu={menu} />
          </div>
        </motion.div>
      )}
    </div>
  );
};
